<script lang="ts">
	import TextArea from '$lib/components/Inputs/TextArea.svelte';
	import { NodeViewWrapper } from 'svelte-tiptap';
	import { _ } from 'svelte-i18n';
	import DragAndDropWrapper from '$lib/components/TextEditor/Components/DragAndDropWrapper/DragAndDropWrapper.svelte';
	import type { NodeViewProps } from '@tiptap/core';
	import type { Post } from '$lib/api/rpc';
	import { onMount } from 'svelte';
	import Button from '$lib/components/Button/Button.svelte';

	export let node: NodeViewProps['node'];
	export let deleteNode: () => void;
	export let updateAttributes: NodeViewProps['updateAttributes'];

	let editMode = node.attrs.isOpen;

	let html = '';

	let post: Post | null = node.attrs.post;

	const save = async () => {
		post = {
			type: 'widget',
			etc: {
				widget: {
					html: `${html}`,
				},
			},
		} as Post;
		updateAttributes({ post, isOpen: false });
		editMode = false;
	};

	onMount(() => {
		post = node.attrs.post;
		if (!post) {
			updateAttributes({ isOpen: true });
			editMode = true;
		}
	});
</script>

<NodeViewWrapper>
	<DragAndDropWrapper on:delete={deleteNode}>
		{#if editMode}
			<TextArea required name="widgetValue" label="HTML" bind:value={html} />
			<footer>
				<Button on:click={deleteNode} displayType="secondary">{$_('common.cancel')}</Button>
				<Button on:click={save}>{$_('common.save')}</Button>
			</footer>
		{:else}
			<div class="widget">
				{@html post?.etc.widget?.html}
			</div>
		{/if}
	</DragAndDropWrapper>
</NodeViewWrapper>

<style>
	.widget :global(iframe) {
		min-block-size: 600px;
		border: none;
	}

	footer {
		display: flex;
		justify-content: flex-end;
		gap: var(--gutterMedium);
		padding-block: var(--gutterSmall);
	}
</style>
